// Copyright 2026 The Gitea Authors. All rights reserved.
// SPDX-License-Identifier: MIT
import {createApp} from 'vue';

export async function initAgentRevision() {
  const el = document.querySelector<HTMLElement>('#agent-revision');
  if (!el) return;

  const pageData = window.config.pageData.agentRevision;
  if (!pageData) return;

  try {
    const {default: AgentRevision} = await import('../components/AgentRevision.vue');
    createApp(AgentRevision, {pageData}).mount(el);
    el.classList.remove('is-loading');
  } catch (err) {
    console.error('AgentRevision failed to load', err);
    el.textContent = 'Agent revision failed to load';
  }
}
